import request from '@/utils/request'
import type { DynamicContentRoutesResult, TopicBodyResult, UrlRecordDto } from '@/types/content'

export const getDynamicContentRoutes = () => {
  return request.get<UrlRecordDto[] | DynamicContentRoutesResult>('/commons/GetUrlRecords')
}

export const getTopicById = (id: number | string) => {
  return request.get<TopicBodyResult>(`/commons/GetTopic/${id}`)
}
